import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ gap: number }>()((theme, { gap }) => ({
    base: {
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        gap,
    },
}));

interface Props {
    children: React.ReactNode;
    classes?: string;
    className?: string;
    gap?: number;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const MenuList = React.forwardRef<HTMLDivElement, Props>(
    (
        {
            children,
            classes: classesProps,
            className: classNameProps,
            gap = 4,
            onClick,
        }: Props,
        ref
    ) => {
        const { classes, cx } = useStyles({ gap });

        return (
            <div
                ref={ref}
                onClick={onClick}
                className={cx(classes.base, classesProps, classNameProps)}>
                {children}
            </div>
        );
    }
);

export default MenuList;
